module.exports = __webpack_public_path__ + "static/you-are-not-so-smart-a4af150b7777fbd227e53fb7d02fa293.jpg";